export class StoreUsersActions {
  static readonly type = '[Users Actions] Store Users Actions';
}

export class StoreUserRole {
  static readonly type = '[Users Actions] Store User Role';
  constructor(public role: string) {}
}
